import { GlEmptyState } from '@gitlab/ui';
export default {
    name: 'FilterEmptyState',
    components: {
        GlEmptyState
    }
};
